import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UserState } from "./userTypes";
import {
  loginSuccess,
  loginFailure,
  logout,
  loginRequest,
  registerFailure,
  registerRequest,
  registerSuccess,
} from "./userActions";
import { SessionManager } from "../../../services/auth/sessionManager";
import { REHYDRATE } from "redux-persist";

const initialState: UserState = {
  openLogout: false,
  userSession: {},
  addAddress: false,
  savingNewAddress: false,
  verifyEmailResponse: {},
  subscription: {
    isLoading: false,
    list: [],
    error: null,
  },
  updateEmailResponse: {},
  updatePhoneResponse: {},
  validateOTPResponse: {},
  resendOTPResponse: {},
  loading: false,
  loginError: null,
  isAuthenticated: SessionManager.hasValidToken(),

  // register state
  registerLoading: false,
  registerError: null,
  registerSuccessMessage: null,
  registerSuccess: false,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    clearRegisterState(state) {
      state.registerLoading = false;
      state.registerError = null;
      state.registerSuccessMessage = "";
      state.registerSuccess = false;
    },

    setLogoutModal(state, action: PayloadAction<boolean>) {
      state.openLogout = action.payload;
    },
    setUserSession(state, action: PayloadAction<Record<string, any>>) {
      state.userSession = action.payload;
    },
    // example reducers to manage array list (add/remove)
    addToSubscriptionList(state, action: PayloadAction<any>) {
      state.subscription.list.push(action.payload);
    },
    removeFromSubscriptionList(state, action: PayloadAction<string>) {
      // assume payload is an id
      state.subscription.list = state.subscription.list.filter(
        (it) => it.id !== action.payload,
      );
    },
    replaceSubscriptionList(state, action: PayloadAction<any[]>) {
      state.subscription.list = action.payload;
    },
    // auth letest 20122025
    setAuthenticated(state, action: PayloadAction<boolean>) {
      state.isAuthenticated = action.payload;
      if (!action.payload) state.userSession = {};
    },
  },
  extraReducers: (builder) => {
    builder.addCase(REHYDRATE as any, (state, action: any) => {
      const incoming = action.payload?.user;
      if (!incoming) return;

      state.isAuthenticated = SessionManager.hasValidToken();
      state.loading = false;

      const inSub = incoming.subscription ?? {};
      state.subscription = {
        list: Array.isArray(inSub.list) ? inSub.list : [],
        isLoading: false,
        error: null,
      };
    });

    builder
      .addCase(loginRequest, (state) => {
        // console.log("Reducer me data aya:", action.payload);
        state.subscription.isLoading = true;
        state.loading = true;
        state.subscription.error = "";

        // console.log("state.userSession", state.userSession);
      })
      .addCase(loginSuccess, (state, action) => {
        // console.log("Reducer me data aya:", action.payload);
        state.userSession = action.payload;
        state.isAuthenticated = true;
        state.subscription.isLoading = true;
        state.loading = false;
        // console.log("state.userSession", state.userSession);
      })
      .addCase(loginFailure, (state, action) => {
        state.userSession = {};
        state.isAuthenticated = false;
        state.subscription.error = action.payload;
        state.subscription.isLoading = false;
        state.loading = false;
      });

    // logout
    builder.addCase(logout, (state) => {
      state.userSession = {};
      state.isAuthenticated = false;
    });

    // register
    builder
      .addCase(registerRequest, (state) => {
        state.registerLoading = true;
        state.registerError = null;
        state.registerSuccessMessage = null;
        state.registerSuccess = false;
      })
      .addCase(registerSuccess, (state, action) => {
        state.registerLoading = false;
        state.registerError = null;
        state.registerSuccess = true;
        // assume backend se message: action.payload.message
        state.registerSuccessMessage =
          (action.payload && action.payload.message) ||
          "OTP sent to your email. Please verify.";
      })
      .addCase(registerFailure, (state, action) => {
        state.registerLoading = false;
        state.registerError = action.payload;
        state.registerSuccessMessage = null;
        state.registerSuccess = false;
      });
  },
});

export const {
  setAuthenticated,
  setLogoutModal,
  setUserSession,
  addToSubscriptionList,
  removeFromSubscriptionList,
  replaceSubscriptionList,
  clearRegisterState,
} = userSlice.actions;
export default userSlice.reducer;

// fetch session
// builder;
// .addCase(fetchSessionRequest, (state) => {
//   state.loading = true;
// })
// .addCase(fetchSessionSuccess, (state, action) => {
//   state.loading = false;
//   state.isAuthenticated = true;
//   state.userSession = action.payload;
// })
// .addCase(fetchSessionFailure, (state, action) => {
//   state.loading = false;
//   state.isAuthenticated = false;
//   state.userSession = {};
//   state.subscription.error = action.payload;
// });
